<template>
  <div>
    <validation-observer ref="documentRef" tag="form">
      <section-title class="mt-3" content="Documentos" :has-line="true" />
      <div
        v-for="(item, index) in documentsFiltered"
        :key="`document-index-${index}`"
      >
        <custom-callout
          class-main="mt-3 rounded"
          :has-border="false"
          :has-toggle="false"
        >
          <div class="row py-2 mr-md-0 align-items-center">
            <div class="col-2 mt-3 mt-md-0">
              <div class="color-gray-6 font-14">Documento:</div>
              <div class="color-black font-16">
                {{ item.documentTypeName | empty }}
              </div>
            </div>
            <div
              v-if="!isRemedyApprovalLetterType(item)"
              class="col-2 mt-3 mt-md-0"
            >
              <div class="color-gray-6 font-14">Archivo:</div>
              <div class="color-black font-16">
                {{ item.filename | empty }}
              </div>
            </div>
            <div v-if="isCopyOfThePeiType(item)" class="col-2 mt-3 mt-md-0">
              <div class="color-gray-6 font-14">Estatus del PEI:</div>
              <div class="color-black font-16">
                {{ item.peiStatusName | empty }}
              </div>
            </div>
            <div v-if="isCopyOfThePeiType(item)" class="col-2 mt-3 mt-md-0">
              <div class="color-gray-6 font-14">Número del PEI:</div>
              <div class="color-black font-16">
                {{ item.peiId | empty }}
              </div>
            </div>
            <div v-if="isCopyOfThePeiType(item)" class="col-2 mt-3 mt-md-0">
              <div class="color-gray-6 font-14">Fecha del PEI:</div>
              <div class="color-black font-16">
                {{ item.peiDate | date }}
              </div>
            </div>
            <div
              v-if="isRemedyApprovalLetterType(item)"
              class="col-2 mt-3 mt-md-0"
            >
              <div class="color-gray-6 font-14">Fecha de Aprobación:</div>
              <div class="color-black font-16">
                {{ item.approvalLetterDate | date }}
              </div>
            </div>
            <div
              class="col mt-3 mt-md-0 d-flex justify-content-end align-items-center"
            >
              <custom-file-input
                v-if="
                  replaceableDocuments.length > 0 &&
                    replaceableDocuments.findIndex(
                      (x) => x.documentTypeId === item.documentTypeId
                    ) !== -1 &&
                    !isDocumentReadOnly(item) &&
                    !isSignedContract
                "
                ref="fileReplacementDocumentInputRef"
                accept=".pdf"
                accept-terms-modal-title="Certificación"
                accept-terms-text="Certifico que este documento que he subido al Sistema REMpro es copia fiel y exacta del original que pertenece a los récords de la Unidad Secretarial del Procedimiento de Querellas y Remedio Provisional (USPQRP) y que como proveedor de servicios seré custodio del mismo. Reconozco y acepto que este documento original me puede ser solicitado por la USPQRP en cualquier momento.(0423)"
                accept-terms-title="Acepto los términos y responsabilidades"
                accept-terms-validation-msg="Favor certifique el documento  que ha subido al sistema REMpro."
                allow-accept-terms
                class="file-replacement-input__extended"
                display-style="normal"
                label-position="left"
                name=" "
                :on-download="() => onDownloadHandler(item)"
                @input="(file) => onReplacementFileHandler(file, item)"
              />
              <action-button
                v-if="
                  canDownloadFile(item) &&
                    canDownloadSignedCopyOfPEIFile(item) &&
                    item.documentTypeId === copyOfPeiDocumentTypeId &&
                    canDownloadBlankPeiReport
                "
                class="btn-action-size ml-2"
                i="fas fa-file-download"
                variant="outline-green"
                @click="() => onDownloadBlankPeiHandler(item)"
              />
              <action-button
                v-if="
                  canDownloadFile(item) &&
                    canDownloadSignedCopyOfPEIFile(item) &&
                    !showRemoveWhenisAuthorizationLetterFromParentsTutor(item)
                "
                class="btn-action-size ml-2"
                i="fas fa-file-download"
                variant="success"
                @click="() => onDownloadHandler(item, index)"
              />
              <action-button
                v-if="
                  item.documentId &&
                    isDocumentReadOnly(item) &&
                    !isForDownloadOnly(item)
                "
                class="btn-action-size"
                i="fas fa-times-circle pl-1"
                variant="outline-danger m-1 pl-1"
                @click="() => onRemoveFileHandler(item)"
              />
              <custom-file-input
                v-if="
                  (!canDownloadFile(item) &&
                    !canAddOrDeleteCompuMinute(item)) ||
                    compuMinuteIsEmpty(item) ||
                    showRemoveWhenisAuthorizationLetterFromParentsTutor(item)
                "
                ref="fileInputRef"
                accept=".pdf"
                accept-terms-modal-title="Certificación"
                accept-terms-text="Certifico que este documento que he subido al Sistema REMpro es copia fiel y exacta del original que pertenece a los récords de la Unidad Secretarial del Procedimiento de Querellas y Remedio Provisional (USPQRP) y que como proveedor de servicios seré custodio del mismo. Reconozco y acepto que este documento original me puede ser solicitado por la USPQRP en cualquier momento.(0423)"
                accept-terms-title="Acepto los términos y responsabilidades"
                accept-terms-validation-msg="Favor certifique el documento  que ha subido al sistema REMpro."
                allow-accept-terms
                :attachment-id="item.documentId"
                class="file-input__extended"
                display-style="normal"
                label-position="left"
                name=" "
                :on-download="() => onDownloadHandler(item)"
                :value="item.attachment"
                @after-remove="onRemoveHandler(item)"
                @input="(file) => onUploadFileHandler(file, item)"
              />
            </div>
          </div>
        </custom-callout>
      </div>
      <div
        v-for="(item, index) in licenseDocuments"
        :key="`licenseDocuments-index-${index}`"
      >
        <custom-callout
          class-main="mt-3 rounded"
          :has-border="false"
          :has-toggle="false"
        >
          <div class="row py-2 mr-md-0 align-items-center">
            <div class="col-2 mt-3 mt-md-0">
              <div class="color-gray-6 font-14">Documento:</div>
              <div class="color-black font-16">
                {{ item.documentTypeName | empty }}
              </div>
            </div>
            <div
              class="col mt-3 mt-md-0 d-flex justify-content-end align-items-center"
            >
              <action-button
                class="btn-action-size"
                i="fas fa-file-download"
                variant="success"
                @click="() => $emit('on-download-license-documents')"
              />
            </div>
          </div>
        </custom-callout>
      </div>
      <validation-provider
        v-slot="{ errors }"
        :rules="{ required: hasRequiredDocuments }"
      >
        <custom-error
          v-if="errors[0]"
          class="mt-2"
          message="Favor subir todos los documentos requeridos en sistema."
          variant="no-border"
        />
      </validation-provider>
    </validation-observer>
  </div>
</template>

<script>
import objectToFormData from 'object-to-formdata';

//libs components
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import SectionTitle from 'SectionTitle';
import CustomCallout from 'custom-callout';
import CustomError from 'custom-error';
import ActionButton from 'ActionButton';
import CustomFileInput from 'CustomFileInput';

//services
import {
  saveContractDocument as _saveContractDocument,
  deleteContractDocument as _deleteContractDocument,
} from '@/services/uspqrp/contract.api.js';

//utils
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin';

//constants
import rpContractDocumentTypes from '@/utils/constants/rpContractDocumentTypes.js';
import rpContractStatus from '@/utils/constants/rpContractStatus.js';

const validContractStatusForUploadSignedContract = [
  rpContractStatus.ApprovedContractInformation,
  rpContractStatus.DeniedContractInformation,
];

export default {
  name: 'RequiredDocuments',
  mixins: [alertMixin],
  components: {
    ValidationObserver,
    ValidationProvider,
    SectionTitle,
    CustomCallout,
    CustomError,
    ActionButton,
    CustomFileInput,
  },
  props: {
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
    documents: {
      type: Array,
      default: () => [],
    },
    contractId: {
      type: Number,
      default: () => null,
    },
    isAmendment: {
      type: Boolean,
      default: () => false,
    },
    academicYearId: {
      type: Number,
      default: () => null,
    },
    contractStatusId: {
      type: Number,
      default: () => null,
    },
  },
  data: () => ({
    hasRequiredDocuments: null,
  }),
  computed: {
    canDownloadBlankPeiReport() {
      return this.userHasPermissions(
        'rempro.providers.contract.candownloadblankpei'
      );
    },
    replaceableDocuments() {
      const result = this.documents.filter((x) => this.isDocReplaceable(x));
      return result;
    },
    copyOfPeiDocumentTypeId() {
      return rpContractDocumentTypes.CopyOfThePEI;
    },
    isForDownloadOnly() {
      return ({ documentTypeId, peiId }) =>
        [
          rpContractDocumentTypes.CopyOfThePEI,
          rpContractDocumentTypes.RemedyApprovalLetter,
          rpContractDocumentTypes.Evaluation,
          rpContractDocumentTypes.CompuMinute,
          rpContractDocumentTypes.SpecialistLicense,
        ].includes(documentTypeId) &&
        !(documentTypeId === rpContractDocumentTypes.CopyOfThePEI && !peiId);
    },
    isCopyOfThePeiType() {
      return ({ documentTypeId }) =>
        documentTypeId === rpContractDocumentTypes.CopyOfThePEI;
    },
    isRemedyApprovalLetterType() {
      return ({ documentTypeId }) =>
        documentTypeId === rpContractDocumentTypes.RemedyApprovalLetter;
    },
    showRemoveWhenisAuthorizationLetterFromParentsTutor() {
      return ({ documentTypeId }) =>
        documentTypeId ===
          rpContractDocumentTypes.AuthorizationLetterFromTheParentsAndOrTutor &&
        this.contractStatusId == rpContractStatus.DeniedContractInformation;
    },
    canDownloadFile() {
      return (item) => item.documentId || item.approvalLetterDate || item.peiId;
    },
    canUploadFile() {
      return (item) =>
        !item?.filename ||
        (item.documentId === rpContractDocumentTypes.CopyOfThePEI &&
          !item.peiId);
    },
    canRemoveFile() {
      return (item) => item.filename;
    },
    isSignedContract() {
      return this.contractStatusId === rpContractStatus.Signed;
    },
    isDocumentReadOnly() {
      const documentTypes = [
        rpContractDocumentTypes.SignedContract,
        rpContractDocumentTypes.CompuMinute,
      ];
      return ({ documentTypeId }) => {
        if (
          !validContractStatusForUploadSignedContract.includes(
            this.contractStatusId
          )
        ) {
          return !this.isReadOnly;
        }
        return (
          documentTypes.includes(documentTypeId) &&
          validContractStatusForUploadSignedContract.includes(
            this.contractStatusId
          )
        );
      };
    },
    hasUploadContractSignedDocument() {
      const signedDocument = this.documents.find(
        (x) => x.documentTypeId == rpContractDocumentTypes.SignedContract
      );

      return Boolean(signedDocument?.documentId || signedDocument?.attachment);
    },
    documentSubmittedAEE() {
      const submitted = this.documents.some(
        (x) =>
          x.isRequiredConditional == 1 &&
          (x.attachment || x.documentId || x.peiId)
      );
      if (!submitted) {
        return this.documents.filter(
          (x) => x.isRequiredConditional == 1 && !(x.attachment || x.documentId)
        );
      }
      return [];
    },
    documentSubmitted() {
      const submitted = this.documents.every(
        (x) => x.isRequired == 1 && (x.attachment || x.documentId || x.peiId)
      );

      if (!submitted) {
        return this.documents.filter(
          (x) => x.isRequired == 1 && !(x.attachment || x.documentId || x.peiId)
        );
      }
      return [];
    },
    documentsFiltered() {
      let documents = this.documents.filter(
        (x) =>
          x.documentTypeId != rpContractDocumentTypes.LicenseDocuments &&
          x.documentTypeId != rpContractDocumentTypes.SignedContract
      );
      if (this.contractStatusId == rpContractStatus.Signed) {
        const signedContractDocument = this.documents.filter(
          (x) => x.documentTypeId == rpContractDocumentTypes.SignedContract
        );
        documents = [...documents, ...signedContractDocument];
      } else if (
        !this.contractStatusId ||
        this.contractStatusId == rpContractStatus.New
      ) {
        documents = this.documents.filter(
          (x) => x.documentTypeId != rpContractDocumentTypes.SignedContract
        );
      }
      return documents;
    },
    licenseDocuments() {
      return this.documents.filter(
        (x) => x.documentTypeId == rpContractDocumentTypes.LicenseDocuments
      );
    },
    canAddOrDeleteCompuMinute() {
      const notAllowedStates = [
        rpContractStatus.New,
        rpContractStatus.ApprovedContractInformation,
        rpContractStatus.DeniedContractInformation,
      ];
      return (item) =>
        item.documentTypeId === rpContractDocumentTypes.CompuMinute &&
        !notAllowedStates.includes(this.contractStatusId);
    },
    compuMinuteIsEmpty() {
      return (item) =>
        item.documentTypeId === rpContractDocumentTypes.CompuMinute &&
        item.filename == null;
    },
  },
  methods: {
    canDownloadSignedCopyOfPEIFile(item) {
      return (
        item.documentTypeId !== rpContractDocumentTypes.CopyOfThePEI ||
        item.canDownloadFromStorage ||
        item.documentId != null ||
        item.peiId
      );
    },
    async onDownloadBlankPeiHandler(item) {
      this.$emit('on-download-blank-pei-report', item);
    },
    async onDownloadHandler(item, itemIndex) {
      if (item) {
        if (item.documentTypeId === rpContractDocumentTypes.CopyOfThePEI) {
          this.$emit('on-download-pei-report', item);
        } else if (
          item.documentTypeId === rpContractDocumentTypes.RemedyApprovalLetter
        ) {
          this.$emit('on-donwload-approval-letter-report');
        } else {
          if (!item.documentId) {
            this.$refs.fileInputRef[itemIndex].downloadFile();
          } else {
            this.$emit('on-download-file', item.documentId);
          }
        }
      }
    },
    async onRemoveHandler(item) {
      item.attachment = null;
      item.filename = null;
      await this.$forceUpdate();
    },
    async onRemoveFileHandler(item) {
      if (this.contractId) {
        await _deleteContractDocument(this.contractId, item.documentTypeId);
        this.$emit('on-refresh-document');
      } else {
        item.attachment = null;
        item.filename = null;
        await this.$forceUpdate();
      }
    },
    async saveContractDocument(
      contractDocumentTypeId,
      file,
      contractDocumentId
    ) {
      const payload = objectToFormData(
        {
          contractDocumentId,
          contractId: this.contractId,
          academicYearId: this.academicYearId,
          contractDocumentTypeId,
          file,
        },
        { indices: true, nullsAsUndefineds: true }
      );
      await _saveContractDocument(payload);
    },
    async onUploadFileHandler(file, item) {
      if (file) {
        if (this.contractId) {
          await this.saveContractDocument(item.documentTypeId, file);
          this.$emit('on-refresh-document');
        } else {
          item.attachment = file;
          item.filename = file.name;
          await this.$forceUpdate();
        }
      }
    },
    async onReplacementFileHandler(file, item) {
      if (file && item.contractDocumentId) {
        await this.saveContractDocument(
          item.documentTypeId,
          file,
          item.contractDocumentId
        );
        this.$refs.fileReplacementDocumentInputRef[0].removeFile();
        this.$emit('on-refresh-document');
      }
    },

    isDocReplaceable(item) {
      const allowedStates = [
        rpContractStatus.Signed,
        rpContractStatus.ContractAmended,
      ];
      const hasReplaceSignedContractDocPermission = this.userHasPermissions(
        'rempro.providers.contract.replacementsignedcontract'
      );
      const hasReplaceDocumentPermission = this.userHasPermissions(
        'rempro.providers.contract.replacementdocument'
      );
      const allowContractStatuses = [
        rpContractStatus.New,
        rpContractStatus.ApprovedContractInformation,
        rpContractStatus.Submitted,
        rpContractStatus.Signed,
      ];

      let allowDocTypes = [rpContractDocumentTypes.CompuMinute];
      switch (this.contractStatusId) {
        case rpContractStatus.Signed:
          if (this.isAmendment) {
            allowDocTypes = [
              ...allowDocTypes,
              rpContractDocumentTypes.MinuteAndPEIThatEvidenceTheAEERecommendations,
              rpContractDocumentTypes.ReassessmentEvidencingTheChangeInFrequencyAndItsMinutesOfTheCOMPUMeeting,
              rpContractDocumentTypes.PEIWithTheCorrespondingAmendments,
              rpContractDocumentTypes.ReportAchievementAndJustification,
              rpContractDocumentTypes.AuthorizationLetterFromTheParentsToReceiveTheServiceByAnotherSpecialist,
            ];
          }
          break;
        case rpContractStatus.ApprovedContractInformation:
          allowDocTypes = [
            ...allowDocTypes,
            rpContractDocumentTypes.SignedContract,
          ];
          break;
        default:
          break;
      }
      const canReplaceSignedContractDoc =
        hasReplaceSignedContractDocPermission &&
        item.documentTypeId === rpContractDocumentTypes.SignedContract &&
        allowedStates.includes(this.contractStatusId) &&
        this.canDownloadFile(item);

      const canReplaceDocument =
        hasReplaceDocumentPermission &&
        allowContractStatuses.some(
          (statusId) => statusId === this.contractStatusId
        ) &&
        allowDocTypes.some((docTypeId) => docTypeId === item.documentTypeId) &&
        this.canDownloadFile(item);

      return canReplaceSignedContractDoc || canReplaceDocument;
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@/shared/scss/config/colors.scss';
.btn-action-size {
  width: 35px;
  height: 35px;
}

.file-input__extended ::v-deep {
  .file-input-container {
    width: 35px;
    height: 35px !important;
    border-color: map-get($colors, 'green');
    em {
      font-size: 18px;
      margin-left: -2px;
    }
    .file-select {
      span {
        display: none;
      }
    }
  }
}

.file-replacement-input__extended ::v-deep {
  .file-input-container {
    width: 35px;
    height: 35px !important;
    border-color: map-get($colors, 'green');
    em {
      font-size: 18px;
      margin-left: -2px;
    }
    em.fas.fa-file-plus.pr-4.text-green:before {
      content: '\f0e2';
    }
    .file-select {
      span {
        display: none;
      }
    }
  }
}

.outline-green {
  color: #2db782;
  background-color: #ffffff;
  border-color: #2db782;
}
</style>
